<template lang="pug">
label.switch
  input(type="checkbox" :value="modelValue" @input="$emit('update:modelValue', !modelValue)" v-bind="$attrs")
  span.slider
</template>
<script setup lang="ts">
defineOptions({
  inheritAttrs: false,
})

defineProps<{ modelValue: boolean }>()

defineEmits<{(e: 'update:modelValue', value: boolean): void}> ()
</script>

<style lang="scss" scoped>
$switch-width: 48px;
$switch-height: 20px;
$switch-gap: 2px;
$transition-time: .2s;

.switch {
  position: relative;
  display: inline-block;
  width: $switch-width;
  height: $switch-height;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: $color-gray;
  -webkit-transition: $transition-time;
  transition: $transition-time;
  border-radius: $switch-height;
}

.slider:before {
  position: absolute;
  content: "";
  height: calc($switch-height - $switch-gap - $switch-gap);
  width: calc($switch-height - $switch-gap - $switch-gap);
  left: $switch-gap;
  bottom: $switch-gap;
  background-color: $color-white;
  -webkit-transition: $transition-time;
  transition: $transition-time;
  border-radius: 50%;
}

input:checked+.slider {
  background-color: $color-black;
}

input:focus+.slider {
  box-shadow: 0 0 2px $color-black;
}

input:checked+.slider:before {
  -webkit-transform: translateX(calc($switch-width - $switch-height));
  -ms-transform: translateX(calc($switch-width - $switch-height));
  transform: translateX(calc($switch-width - $switch-height));
}
</style>